import ManageFicheConsultation from '@/views/parametres/configs/param-fiche-medical/manage-fiche-consultation'
import KineConfiguration from '@/views/parametres/configs/param-fiche-medical/kine-configuration'
import store_fiche from "@/store/mods/consultations/fiche-consultations"
import $ from 'jquery'

export default {
    name: 'liste-fiche-consultation',
    components: {
        ManageFicheConsultation, KineConfiguration
    },
    props: {
        selected_consultation: Object,
        info_user: Object,
        liste_autre_consultations: Array,
        activeRole: Object
    },
    data() {
        return {
            selected_fiche: {},
            liste_sections: [],
            fields: [
				'fiche', 'auteur', 'statut',  { key: 'actions', label: 'Action.s' }
			],
			filter_fiche: "",
			perPage: -1,
			currentPage: 1,

            fiche_loading: true,
            fiche_empty: false,
            fiche_consultations: [],
            fiche_error: '',
            editor_loading: false,
            editor_mode: 'create',

            modal_toggler: 0,
            has_access: false,
            access_checker_loading: true,
            kine_visible: false
        }
    },

    computed: {
        kine_enabled() {
            return process.env.VUE_APP_KINE_CONFIGURATION_ENABLED === 'true'
                && this.activeRole && this.activeRole.nom === 'ROLE_ADMINISTRATEUR'
        },
        standard_fiche() {
            return this.fiche_consultations.find(fiche => fiche.type_consultation_id == null) || null
        },
    },

    mounted() {
        this.selectListeFicheConsultation()
        this.checkUserAccessToTypeConsultation()
    },

    methods: {
        openKine() { if (this.kine_enabled) this.kine_visible = true },
        requestLeave(callback) {
            if (this.kine_visible && this.$refs.kine_configuration) this.$refs.kine_configuration.requestLeave(callback)
            else callback()
        },
        libelleFiche(fiche) {
            return /^(fiche patient|fiche consultation mod[eè]le standard)$/i.test((fiche.libelle || '').trim())
                ? 'Fiche consultation modèle standard' : fiche.libelle
        },
        selectListeFicheConsultation() {
            this.fiche_loading = true
            this.fiche_error = ''
            store_fiche.getListeFicheConsultation(this.selected_consultation.id).then((fiches) => {
                this.fiche_consultations = fiches

                if (fiches.length == 0) {
                    this.fiche_empty = true
                } else {
                    this.fiche_empty = false
                }
                this.fiche_loading = false
            }).catch(() => {
                this.fiche_loading = false
                this.fiche_error = 'Impossible de charger les fiches.'
            })
        },

        addFiche() {
            this.openEditor('create', this.standard_fiche)
        },

        peutModifier(fiche) {
            return this.activeRole.nom === 'ROLE_ADMINISTRATEUR'
                || (fiche.type_consultation_id != null && Number(fiche.user_id) === Number(this.info_user.id))
        },

        async openEditor(mode, fiche) {
            this.editor_loading = true
            this.fiche_error = ''
            try {
                const sections = fiche ? await store_fiche.getSectionByTypeConsultation({
                    type_consultation_id: this.selected_consultation.id,
                    fiche_consultation_id: fiche.id
                }) : []
                this.selected_fiche = fiche || {}
                this.liste_sections = Array.isArray(sections) ? sections : []
                this.editor_mode = mode
                this.modal_toggler = this.modal_toggler === 0 ? 1 : 0
                this.$nextTick(() => $('.add-fiche').modal('show'))
            } catch (error) {
                this.fiche_error = 'Impossible de préparer le modèle. Réessayez.'
            } finally {
                this.editor_loading = false
            }
        },

        configurer(fiche_data) {
            let data = {
                fiche_data: fiche_data,
                go_to_page: 'liste_section'
            }
            this.$emit('emitGoTo', data)
        },

        checkUserAccessToTypeConsultation() {
            this.access_checker_loading = true
            const data = {
                data_type: 'type_consultation',
                user_id: this.info_user.id,
                data_id: this.selected_consultation.id
            }

            store_fiche.checkUserAccessOnTypePrestation(data).then((response) => {
                
                if (response.success) {
                    this.has_access = response.has_access
                } else {
                    this.has_access = 0
                }

                this.access_checker_loading = false
            }).catch(() => {
                this.access_checker_loading = false
                this.has_access = 0
            })
        },

        configDefaultFiche() {
            this.modal_toggler = (this.modal_toggler == 0)?1:0
            $('.c-default').modal('show')
        }
    }
}
